/**
 * Format an integer price (in pence) for display
 *
 * @param netPrice
 * @returns {string}
 */
export function formatPriceLabel(netPrice) {
	let priceString = (netPrice / 100).toFixed(2)
	return '£' + priceString.replace('.00', '')
}
